import { render, staticRenderFns } from "./AssignPassword.vue?vue&type=template&id=5fb2d1b4"
import script from "./AssignPassword.vue?vue&type=script&lang=js"
export * from "./AssignPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports